import React from 'react'
import { Link } from 'react-router-dom'
import { InputGroup, Button } from '../../UI'

const forgottenPasswordFrom = ({ handleInput, formData, loading }) => {
  return (
     <>
      <InputGroup
        label="Email"
        name="email"
        type="email"
        required={true}
        placeholder={'Enter your Email'}
        value={formData.email}
        onChange={handleInput}
        error={false}
      />
        <Button
        full
        type="submit"
        className="auth--btn"
        loading={loading}
        spinnerWithTxt={true}
              >
        Submit
      </Button>
      <footer>
        <p>
          remember your password? <Link to="/auth/sign-in">log in</Link>
        </p>
      </footer>
    </>
  )
}

export default forgottenPasswordFrom
